// generateStudentsReports.js
import { toast } from 'sonner';

export async function generateStudentsReports({ students, isAll, emailToSend, downloadAsPdf, year, month }) {
    const url = `${process.env.REACT_APP_API_URL}/admin/reportes-masivos/generate-students-reports?year=${year}&month=${month}`;
    const token = sessionStorage.getItem('token');

    try {
        if (!emailToSend || !token) {
            toast.error("Email o sesión inválidos");
            throw new Error('Missing email or authentication token');
        }

        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                students,
                isAll,
                emailToSend,
                downloadAsPdf
            })
        });

        if (!response.ok) {
            const errorText = await response.text();
            console.error('Server responded with:', errorText);
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.text();
        return result;

    } catch (error) {
        console.error('Error generating students reports:', error);
        throw error;
    }
}